export default __webpack_public_path__ + "static/media/icon-points-blue.71f30ef4.svg";